/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from 'react';
import Router, { useRouter } from 'next/router';

const useClientSideRoutingLoading = () => {
    const [loading, setLoading] = useState(false);

    const { asPath: source } = useRouter();

    const startLoading = (target: string) => {
        const sourceIsMap = source.includes('/map/');
        const targetIsMap = target.includes('/map/');

        if (sourceIsMap && targetIsMap) {
            //do not show loading for clientside routing on maps page.
            setLoading(false);
        } else {
            setLoading(true);
        }
    };
    const stopLoading = () => {
        setLoading(false);
    };

    useEffect(() => {
        // Handling loading while using getInitialProps https://github.com/vercel/next.js/issues/3822
        Router.events.on('routeChangeStart', startLoading);
        Router.events.on('routeChangeComplete', stopLoading);

        return () => {
            Router.events.off('routeChangeStart', startLoading);
            Router.events.off('routeChangeComplete', stopLoading);
        };
    }, [Router.events]);

    return loading;
};

export default useClientSideRoutingLoading;
